import { render } from "./wallet_put.vue?vue&type=template&id=e4736908"
import script from "./wallet_put.vue?vue&type=script&lang=js"
export * from "./wallet_put.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__